import { render, staticRenderFns } from "./classCategory.vue?vue&type=template&id=2b78bed5&"
import script from "./classCategory.vue?vue&type=script&lang=js&"
export * from "./classCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports